import axios from 'axios';

const axiosBackend = axios.create({
  baseURL:'http://34.200.125.181:5028/api/v1',
  responseType: 'json'
});

export default axiosBackend;

